import { makeVar } from "@apollo/client"

const newDeviceClientAvailableVar = makeVar(false)

export { newDeviceClientAvailableVar }
